export default __webpack_public_path__ + "static/media/icon-report-date.5ed8f248.svg";